// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__1Ylka","Main":"Navigation_Main__3tcWY","Nav":"Navigation_Nav__2idgM"};